module.exports = function () {
  var html = "\n      <div class=\"theses-overlay\" id=\"theses-overlay\">\n        <div class=\"status\"></div>\n      </div>\n  ";
  return html;
};